const recipes = [
  {
    id: "recipe-01",
    slug: "silky-tomato-spaghetti",
    title: "Silky Tomato Spaghetti for Two",
    excerpt:
      "A bright, glossy tomato sauce built in the time it takes the pasta to cook.",
    category: "Weeknight pasta",
    readTime: "4 min read",
    time: "25 minutes",
    serves: "2",
    featured: true,
    productIds: [1, 7, 11],
    image: "/editorial/recipe-tomato-spaghetti.jpg",
    intro:
      "Crush the tomatoes by hand, warm them gently with olive oil, then finish the spaghetti in the pan with enough cooking water to bring everything together.",
    notes:
      "Salt the pasta water with restraint: the sauce reduces and the finishing water carries seasoning of its own. A final uncooked drizzle of olive oil adds fragrance.",
  },
  {
    id: "recipe-02",
    slug: "lemon-porcini-pappardelle",
    title: "Lemon Porcini Pappardelle",
    excerpt:
      "Wide egg ribbons, savory mushroom seasoning, and lemon oil in one generous bowl.",
    category: "Weeknight pasta",
    readTime: "5 min read",
    time: "30 minutes",
    serves: "4",
    featured: false,
    productIds: [3, 12, 17],
    image: "/editorial/recipe-lemon-porcini.jpg",
    intro:
      "Bloom the porcini seasoning in butter or olive oil, loosen with pasta water, and fold in the ribbons just until the sauce clings.",
    notes:
      "Add the lemon oil away from direct heat so its aroma stays vivid. Parsley or tender celery leaves make a fresh finish.",
  },
  {
    id: "recipe-03",
    slug: "carnaroli-risotto-tomato",
    title: "Tomato Carnaroli Risotto",
    excerpt:
      "Creamy rice with a lively tomato center and a deeply savory finish.",
    category: "Slow suppers",
    readTime: "6 min read",
    time: "45 minutes",
    serves: "4",
    featured: true,
    productIds: [5, 8, 13],
    image: "/editorial/recipe-tomato-risotto.jpg",
    intro:
      "Toast the rice until the grains feel warm, then add hot stock in stages. Stir the passata in halfway through so the tomato stays clear and balanced.",
    notes:
      "Rest the finished risotto for two minutes before serving. A few drops of wine vinegar sharpen the sweetness without announcing themselves.",
  },
  {
    id: "recipe-04",
    slug: "crispy-polenta-olive-board",
    title: "Crispy Polenta Aperitivo Board",
    excerpt:
      "Golden polenta squares with olives, pepper sugo, and salty little finishing touches.",
    category: "Aperitivo",
    readTime: "5 min read",
    time: "55 minutes, plus chilling",
    serves: "6",
    featured: false,
    productIds: [6, 10, 18],
    image: "/editorial/recipe-polenta-board.jpg",
    intro:
      "Cook the polenta until thick, spread it on a tray, and chill. Cut into small squares and pan-crisp shortly before friends arrive.",
    notes:
      "Set out warm sugo for dipping and scatter olives around the board. The polenta can be cooked a day ahead.",
  },
  {
    id: "recipe-05",
    slug: "orecchiette-fennel-crumbs",
    title: "Orecchiette with Fennel Crumbs",
    excerpt:
      "Toasty breadcrumbs, aromatic fennel pollen, and cupped pasta that catches every bit.",
    category: "Vegetable table",
    readTime: "4 min read",
    time: "30 minutes",
    serves: "4",
    featured: false,
    productIds: [4, 11, 16],
    image: "/editorial/recipe-orecchiette.jpg",
    intro:
      "Toast breadcrumbs in olive oil until crisp, then season with fennel pollen. Toss the pasta with sautéed greens before adding the crumbs at the table.",
    notes:
      "Keep half the crumbs separate until serving so their texture stays lively. Broccoli rabe, kale, or escarole all work well.",
  },
  {
    id: "recipe-06",
    slug: "hazelnut-cantucci-affogato",
    title: "Hazelnut Cantucci Affogato",
    excerpt:
      "A five-minute dessert of cold cream, dark espresso, and crisp almond biscuits.",
    category: "Something sweet",
    readTime: "3 min read",
    time: "10 minutes",
    serves: "4",
    featured: true,
    productIds: [19, 20, 23],
    image: "/editorial/recipe-affogato.jpg",
    intro:
      "Spoon a little hazelnut crema into chilled glasses, add gelato, and pour over freshly brewed espresso just before serving.",
    notes:
      "Serve the cantucci alongside rather than underneath so every bite keeps its crunch. Unsweetened whipped cream is a lovely alternative to gelato.",
  },
];

const journalEntries = [
  {
    id: "journal-01",
    slug: "bronze-dies-and-better-sauce",
    title: "Why Bronze-Cut Pasta Holds Sauce Differently",
    excerpt:
      "Texture is not a decorative detail—it changes how pasta, water, and sauce become one dish.",
    category: "Pantry knowledge",
    readTime: "6 min read",
    featured: true,
    productIds: [1, 2, 4],
    image: "/editorial/journal-bronze-pasta.jpg",
    intro:
      "A rough pasta surface creates countless small places for sauce to settle. Gentle drying protects both that texture and the grain's quiet sweetness.",
    notes:
      "Look beyond shape when choosing a package: extrusion, drying temperature, and flour quality all influence the final bowl.",
  },
  {
    id: "journal-02",
    slug: "olive-oil-at-the-table",
    title: "Keeping Olive Oil Close at Hand",
    excerpt:
      "Fresh oil belongs in everyday cooking, from the first sizzle to the final fragrant pour.",
    category: "Kitchen rituals",
    readTime: "5 min read",
    featured: true,
    productIds: [11, 12],
    image: "/editorial/journal-olive-oil.jpg",
    intro:
      "Store olive oil away from heat and light, use it generously, and notice how its aroma changes a finished plate.",
    notes:
      "A smaller bottle used promptly often tastes better than a large bottle kept for special occasions. The best occasion is dinner tonight.",
  },
  {
    id: "journal-03",
    slug: "tomato-preserve-pantry-map",
    title: "Whole, Strained, or Sauced: A Tomato Pantry Map",
    excerpt:
      "Three useful tomato formats, three different routes to a satisfying supper.",
    category: "Pantry knowledge",
    readTime: "7 min read",
    featured: false,
    productIds: [7, 8, 9],
    image: "/editorial/journal-tomato-map.jpg",
    intro:
      "Whole tomatoes give you control, passata offers a smooth beginning, and finished sauce makes speed possible without giving up character.",
    notes:
      "Choose by texture as much as by time. A rustic braise welcomes hand-crushed fruit; a delicate soup may want the ease of passata.",
  },
  {
    id: "journal-04",
    slug: "aperitivo-without-a-plan",
    title: "How to Make Aperitivo Without a Plan",
    excerpt:
      "A few shelf-stable essentials turn the hour before dinner into its own small pleasure.",
    category: "At the table",
    readTime: "4 min read",
    featured: false,
    productIds: [14, 15, 18],
    image: "/editorial/journal-aperitivo.jpg",
    intro:
      "Begin with contrast: something briny, something crisp, something sweet-sharp, and enough bread to carry it all.",
    notes:
      "Keep the arrangement loose and replenish in small amounts. Aperitivo feels most inviting when no one is worried about keeping it perfect.",
  },
  {
    id: "journal-05",
    slug: "gift-a-working-pantry",
    title: "The Case for Gifting a Working Pantry",
    excerpt:
      "The most memorable food gifts earn a place in tomorrow's dinner, not only on today's table.",
    category: "Giving well",
    readTime: "5 min read",
    featured: true,
    productIds: [5, 9, 11],
    image: "/editorial/journal-pantry-gift.jpg",
    intro:
      "Pair one foundational ingredient with something celebratory and include a clear invitation for how to use both.",
    notes:
      "A good pantry gift can be generous without being oversized. Thoughtful editing and a handwritten note do most of the work.",
  },
  {
    id: "journal-06",
    slug: "after-dinner-italian-pantry",
    title: "Building an Unhurried After-Dinner Shelf",
    excerpt:
      "Coffee, biscuits, preserves, and herbal tea make it easy to let the evening continue.",
    category: "Kitchen rituals",
    readTime: "6 min read",
    featured: false,
    productIds: [20, 22, 24],
    image: "/editorial/journal-after-dinner.jpg",
    intro:
      "An after-dinner shelf is less about formal dessert and more about having a few small, dependable pleasures ready to share.",
    notes:
      "Mix crisp and soft textures, offer both caffeinated and herbal cups, and let everyone assemble their own ending to the meal.",
  },
];

export { journalEntries, recipes };
